"use strict";

import { modal } from "../../modules/_modal";

modal();
window.addEventListener("DOMContentLoaded", () => {});
